(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["infinite-scroll-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-infinite-scroll')) {
    class ProductInfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.gridContainer = this.closest('#ProductGridContainer');
        this.grid = this.gridContainer?.querySelector('.product-grid');
        this.pagination = this.gridContainer?.querySelector('[data-infinite-scroll-pagination]');
        this.status = this.querySelector('[data-infinite-scroll-status]');
        this.nextUrl = this.dataset.nextUrl;

        if (!this.grid || !this.nextUrl || !('IntersectionObserver' in window)) return;

        this.abortController = new AbortController();
        this.pagination?.setAttribute('hidden', '');
        this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries), {
          rootMargin: '600px 0px',
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
      }

      handleIntersection(entries) {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
      }

      async loadNextPage() {
        if (this.isLoading || !this.nextUrl) return;

        this.isLoading = true;
        this.dataset.loading = 'true';
        this.status?.removeAttribute('hidden');
        this.observer?.unobserve(this);

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.abortController.signal,
          });

          if (!response.ok) throw new Error(`Infinite scroll request failed: ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextContainer = html.querySelector('#ProductGridContainer');
          const nextGrid = nextContainer?.querySelector('.product-grid');
          const nextLoader = nextContainer?.querySelector('product-infinite-scroll');
          const nextPagination = nextContainer?.querySelector('[data-infinite-scroll-pagination]');

          if (!nextGrid || !nextLoader) throw new Error('Infinite scroll response is incomplete');

          const newItems = Array.from(nextGrid.children);
          const fragment = document.createDocumentFragment();
          newItems.forEach((item) => fragment.appendChild(item));
          this.grid.appendChild(fragment);

          if (nextPagination && this.pagination) this.pagination.innerHTML = nextPagination.innerHTML;

          this.pagination?.querySelectorAll('a[href]').forEach((link) => {
            link.setAttribute('href', this.cleanSectionUrl(link.getAttribute('href')));
          });

          this.nextUrl = this.cleanSectionUrl(nextLoader.dataset.nextUrl);
          this.dataset.nextUrl = this.nextUrl;

          if (!this.nextUrl) {
            this.pagination?.remove();
            this.remove();
            return;
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.pagination?.removeAttribute('hidden');
          this.remove();
          return;
        } finally {
          this.isLoading = false;
          delete this.dataset.loading;
          this.status?.setAttribute('hidden', '');
        }

        this.observer?.observe(this);
      }

      cleanSectionUrl(rawUrl) {
        if (!rawUrl) return '';

        const url = new URL(rawUrl, window.location.origin);
        url.searchParams.delete('section_id');
        return `${url.pathname}${url.search}${url.hash}`;
      }
    }

    customElements.define('product-infinite-scroll', ProductInfiniteScroll);
  }
  } catch(e) { console.error(e); }
})();

})();
